import { RHFCombobox } from '@talentmesh/ui/components/rhf-combobox';
import { JobDetailsFieldTypes } from '../JobDetailsStepUtils';
import { JobAdLanguage } from '@/Models/JobAdLanguage';
import { languages } from '@/Utils/JobAdLanguage/JobAdLanguages';
import UIStrings from '@/Utils/UIStrings';

interface JobDescriptionLanguageProps {
    disabled?: boolean;
}

function JobDescriptionLanguage({ disabled }: JobDescriptionLanguageProps) {
    return (
        <div className="flex min-w-0 flex-1 flex-col gap-2">
            <RHFCombobox<JobAdLanguage>
                name={JobDetailsFieldTypes.JobDescriptionLanguage}
                label={UIStrings.JobDescriptionLanguage}
                options={languages}
                disabled={disabled}
                fieldDataCy={JobDetailsFieldTypes.JobDescriptionLanguage}
            />
        </div>
    );
}

export default JobDescriptionLanguage;
